import React from 'react';
import PropTypes from 'prop-types';
import { MANIFEST_TYPE } from 'Manifest/constants';

export const Ncc = (props) => {
  const {
    handleSubmit,
    errors = {},
    manifestFormActions,
    onChange,
    form,
    sup_name,
    sphone,
    curDate,
    formatDate,
    crewOptions,
    vehicleOptions,
    handleOnViewResourceOrderForm,
    manifestType,
    viewOnly = false,
    printManifest = () => {},
  } = props;

  return (
    <div
      id='view_print_manifest'
      className='print_manifest_wrap ncc_manifest_wrapper'
    >
      <h2>{viewOnly ? 'View' : 'Finalize'} Manifest</h2>
      <form id='form2' onSubmit={handleSubmit}>
        <fieldset disabled={viewOnly}>
          <div
            className='responsive_table ncc_view_manifest'
            id='general_information_table'
          >
            <div className='top_table table'>
              <div className='tr'>
                <div className='print_center td' colSpan='5'>
                  <h3>Hand Crew Manifest Form</h3>
                </div>
              </div>
              <div className='tr ncc_ordering'>
                <div className='td' data-header-title='Ordering Unit'>
                  <h4>Ordering Unit</h4>
                  <input
                    type='text'
                    errors={errors.unitError}
                    placeholder='Fill...'
                    id={'orderingUnit' + manifestType}
                    name='ordering_unit'
                    value={form.ordering_unit}
                    onChange={onChange}
                  />
                </div>
                <div className='td' data-header-title='Incident Name'>
                  <h4>Incident Name</h4>
                  <input
                    type='text'
                    errors={errors.incidentNameError}
                    placeholder='Fill...'
                    id={'incidentName' + manifestType}
                    name='incident_name'
                    value={form.incident_name}
                    onChange={onChange}
                  />
                </div>
                <div className='td' data-header-title='Incident Number'>
                  <h4>Incident Number</h4>
                  <input
                    type='text'
                    errors={errors.IncidentNumError}
                    placeholder='Fill...'
                    id={'incidentNumber' + manifestType}
                    name='incident_number'
                    value={form.incident_number}
                    onChange={onChange}
                  />
                </div>
                <div
                  className='td_split td'
                  data-header-title='Resource Number'
                >
                  <h4>Resource Number</h4>
                  <b>C-</b>{' '}
                  <span>
                    <input
                      type='text'
                      errors={errors.resourceError}
                      placeholder='Fill...'
                      id={'resourceNumber' + manifestType}
                      name='resource_number'
                      value={form.resource_number}
                      onChange={onChange}
                    />
                  </span>
                </div>
              </div>
            </div>

            <div className='top_table no_border table'>
              <div className='tr'>
                <div width='36%' className='td' data-header-title='Contractor'>
                  <h4>Contractor</h4>
                  <p>Firestorm Wildland Fire Supression Inc.</p>
                </div>
                {manifestType === MANIFEST_TYPE.TYPE_2 && (
                  <div className='td' data-header-title='Agreement Number'>
                    <h4>Agreement Number</h4>
                    <span>
                      <input
                        type='text'
                        errors={errors.ifcaError}
                        placeholder='Fill...'
                        id={'ifcaNumber' + manifestType}
                        name='ifca_number'
                        value={form.ifca_number}
                        onChange={onChange}
                      />
                    </span>
                  </div>
                )}
                <div
                  className='td'
                  data-header-title='Designated Dispatch Location'
                >
                  <h4>Designated Dispatch Location</h4>
                  {manifestType === MANIFEST_TYPE.NCC ? (
                    <input
                      type='text'
                      errors={errors.dispatchError}
                      placeholder='Fill...'
                      id={'dispatchLocation' + manifestType}
                      name='dispatch_location'
                      value={form.dispatch_location}
                      onChange={onChange}
                    />
                  ) : (
                    <p>{form.dispatch_location}</p>
                  )}
                </div>
              </div>
              <div className='tr'>
                <div
                  className='td'
                  data-header-title='Contractor Represntative'
                >
                  <h4>Contractor Represntative</h4>
                  <p id='sup_det_create'>{sup_name}</p>
                </div>
                {manifestType === MANIFEST_TYPE.NCC ? (
                  <>
                    <div className='td' data-header-title='Report To'>
                      <h4>Report To:</h4>
                      <input
                        type='text'
                        errors={errors.reportToError}
                        placeholder='Fill...'
                        id='reportTo3'
                        name='report_to'
                        value={form.report_to}
                        onChange={onChange}
                      />
                    </div>
                    <div className='td' data-header-title='If Delayed, Contact'>
                      <h4>If Delayed, Contact:</h4>
                      <p id='sup_phone_create'>{sphone}</p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className='td' data-header-title='If Delayed, Contact'>
                      <h4>Contact Phone:</h4>
                      <p id='sup_phone_create'>{sphone}</p>
                    </div>
                    <div className='td' data-header-title='Report To'>
                      <h4>Report To:</h4>
                      <input
                        type='text'
                        errors={errors.reportToError}
                        placeholder='Fill...'
                        id='reportTo8'
                        name='report_to'
                        value={form.report_to}
                        onChange={onChange}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className='top_table no_border table ncc_place'>
              <div className='tr outer_place_div'>
                <div width='36%' className='print_center no_padding_border td'>
                  <div className='top_table no_border table'>
                    <div className='tr'>
                      <div
                        className='print_center td_height td'
                        colSpan='3'
                        data-header-title='Departure'
                      >
                        <h5>Departure</h5>
                      </div>
                    </div>
                    <div className='tr ncc_dep'>
                      <div
                        width='50%'
                        className='double_field td'
                        data-header-title='Place'
                      >
                        <h5>Place</h5>
                        <span>
                          <input
                            type='text'
                            errors={errors.depPlaceError}
                            placeholder='Fill...'
                            id={'depPlace' + manifestType}
                            name='dep_place'
                            value={form.dep_place}
                            onChange={onChange}
                          />
                        </span>
                      </div>
                      <div className='double_field td' data-header-title='ETD'>
                        <h5>ETD</h5>
                        <span>
                          <input
                            type='text'
                            maxLength={4}
                            errors={errors.depEtdError}
                            placeholder='Fill...'
                            id='depETD8'
                            name='dep_etd'
                            value={form.dep_etd}
                            onChange={onChange}
                          />
                        </span>
                      </div>
                      {manifestType == MANIFEST_TYPE.TYPE_2 && (
                        <div
                          className='double_field td'
                          data-header-title='ETA'
                        >
                          <h5>ETA</h5>
                          <span>
                            <input
                              type='text'
                              maxLength={4}
                              errors={errors.desEtdError}
                              placeholder='Fill...'
                              id='depETA8'
                              name='dep_eta'
                              value={form.dep_eta}
                              onChange={onChange}
                            />
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className='print_center no_padding_border td' width='23%'>
                  <div className='top_table no_border table'>
                    <div className='tr'>
                      <div
                        className='print_center td_height td'
                        colSpan='2'
                        data-header-title='Intermediate Stops'
                      >
                        <h5>Intermediate Stops</h5>
                      </div>
                    </div>
                    <div className='tr ncc_inter'>
                      {manifestType == MANIFEST_TYPE.NCC && (
                        <div
                          className='double_field td'
                          data-header-title='ETA'
                        >
                          <h5>ETA</h5>
                          <span>
                            <input
                              type='text'
                              errors={errors.interEtaError}
                              placeholder='Fill...'
                              id='inter_eta3'
                              name='inter_eta'
                              value={form.inter_eta}
                              onChange={onChange}
                            />
                          </span>
                        </div>
                      )}
                      <div
                        className='double_field td'
                        data-header-title='Place'
                      >
                        <h5>Place</h5>
                        <span>
                          <input
                            type='text'
                            errors={errors.interSpaceError}
                            placeholder='Fill...'
                            id={'interSpace' + manifestType}
                            name='inter_space'
                            value={form.inter_space}
                            onChange={onChange}
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='print_center no_padding_border td'>
                  <div className='top_table no_border table'>
                    <div className='tr'>
                      <div
                        className='print_center td_height td'
                        colSpan='3'
                        data-header-title='Destination'
                      >
                        <h5>Destination</h5>
                      </div>
                    </div>
                    <div className='tr ncc_des'>
                      {manifestType == MANIFEST_TYPE.TYPE_2 && (
                        <div
                          className='double_field td'
                          data-header-title='Place'
                        >
                          <h5>Place</h5>
                          <span>
                            <input
                              type='text'
                              errors={errors.desPlaceError}
                              placeholder='Fill...'
                              id={'desPlace' + manifestType}
                              name='des_place'
                              value={form.des_place}
                              onChange={onChange}
                            />
                          </span>
                        </div>
                      )}
                      <div
                        className='double_field td flex-des'
                        data-header-title='ETD'
                      >
                        <h5>ETD</h5>
                        <span>
                          <input
                            type='text'
                            maxLength={4}
                            errors={errors.desEtdError}
                            placeholder='Fill...'
                            id={'desETD' + manifestType}
                            name='des_etd'
                            value={form.des_etd}
                            onChange={onChange}
                          />
                        </span>
                      </div>
                      <div
                        className='double_field td flex-des'
                        data-header-title='ETA'
                      >
                        <h5>ETA</h5>
                        <span>
                          <input
                            type='text'
                            maxLength={4}
                            errors={errors.desEtaError}
                            placeholder='Fill...'
                            id={'desETA' + manifestType}
                            name='des_eta'
                            value={form.des_eta}
                            onChange={onChange}
                          />
                        </span>
                      </div>
                      {manifestType == MANIFEST_TYPE.NCC && (
                        <div
                          className='double_field td'
                          data-header-title='Place'
                        >
                          <h5>Place</h5>
                          <span>
                            <input
                              type='text'
                              errors={errors.desPlaceError}
                              placeholder='Fill...'
                              id={'desPlace' + manifestType}
                              name='des_place'
                              value={form.des_place}
                              onChange={onChange}
                            />
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className='table top_table table_space ncc_employee_details'
            id='view_employee_details_table'
          >
            <p className='mobile_crew'>Employee Details</p>
            <div className='thead'>
              <div className='tr'>
                <div
                  className='print_center th'
                  data-header-title='Employee Name (Last, First)'
                >
                  <h4>Employee Name (Last, First)</h4>
                </div>
                <div className='print_center gender th' data-header-title='M'>
                  <h4>M</h4>
                </div>
                <div className='print_center gender th' data-header-title='F'>
                  <h4>F</h4>
                </div>
                <div
                  className='print_center th'
                  data-header-title='Identification Number'
                >
                  <h4>
                    Identification
                    <br />
                    Number
                  </h4>
                </div>
                <div
                  className='print_center th'
                  data-header-title='Incident Position'
                >
                  <h4>
                    Incident
                    <br />
                    Position
                  </h4>
                </div>
                <div
                  className='print_center th sawyer'
                  data-header-title='Sawyer Class'
                >
                  <h4>Sawyer</h4>
                </div>
                {manifestType === MANIFEST_TYPE.TYPE_2 && (
                  <div className='print_center th emt' data-header-title='EMT'>
                    <h4>EMT</h4>
                  </div>
                )}
                <div
                  className='print_center th'
                  data-header-title='Experience Blue-Red-Yellow (B_R_Y)'
                >
                  {manifestType == MANIFEST_TYPE.TYPE_2 && (
                    <h4>
                      Experience and LSA
                      <br />
                      <span>(B-R-Y=Blue-Red-Yellow)</span>
                    </h4>
                  )}
                  {manifestType == MANIFEST_TYPE.NCC && (
                    <h4>
                      Experience
                      <br />
                      <span>Blue-Red-Yellow (B_R_Y)</span>
                    </h4>
                  )}
                </div>
              </div>
            </div>
            <div className='tbody'>{crewOptions}</div>
          </div>
          <div className='responsive_table view_driver_vehicle_div_ncc'>
            <h3 className='inner_head_title driver_vehicle_title'>
              Driver and Vehicle Information
            </h3>

            <div
              className='top_table no_border table'
              id='view_driver_vehicle_table'
            >
              <div className='thead'>
                <div className='tr'>
                  <div className='no_border_td_right th'>
                    <h6>Driver Name</h6>
                  </div>
                  {manifestType == MANIFEST_TYPE.TYPE_2 && (
                    <div className='no_border_td_right th'>
                      <h6>DL/MSPA Exp. Date</h6>
                    </div>
                  )}
                  <div className='no_border_td_right th'>
                    <h6>Vehicle Make/Model</h6>
                  </div>
                  <div className='no_border_td_right th st'>
                    <h6>Year</h6>
                  </div>
                  <div className='no_border_td_right th exp_date'>
                    <h6>Vehicle License No.</h6>
                  </div>
                </div>
              </div>
              <div className='tbody'>{vehicleOptions}</div>
            </div>
          </div>

          <div className='table top_table last_table ncc_sign'>
            <div className='tr'>
              <div className='td'>
                <span className='title_bottom'>
                  Contractor Representative Name (Print)
                </span>
                <br />
                <p id='sup_det_create'>{sup_name}</p>
              </div>
              <div className='td'>
                <span className='title_bottom'>Date</span>
                <br />
                <p className='print_date'>{formatDate(curDate)}</p>
              </div>
              <div className='td'>
                <span className='title_bottom'>Contact Phone Number</span>
                <br />
                <p id='sup_phone_create'>{sphone}</p>
              </div>
            </div>
          </div>
          <div className='clearFix' />
          {manifestFormActions}
        </fieldset>
        {viewOnly && (
          <div className='gear-option-btn-wrap'>
            <input
              type='button'
              id='to_view_final_print'
              className={`button save_manifest`}
              name='print'
              onClick={printManifest}
              value='Print Manifest'
            />
            {form.resource_order_form && (
              <input
                type='button'
                id='view_ROF'
                onClick={() => handleOnViewResourceOrderForm()}
                value='View RO'
                name='view_ROF'
                className={`button save_manifest}`}
              />
            )}
          </div>
        )}
      </form>
    </div>
  );
};

Ncc.propTypes = {
  dispatch_location: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  errors: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  sup_name: PropTypes.string.isRequired,
  sphone: PropTypes.string.isRequired,
  curDate: PropTypes.object.isRequired,
  formatDate: PropTypes.func.isRequired,
  crewOptions: PropTypes.array.isRequired,
  vehicleOptions: PropTypes.array.isRequired,
  handleOnViewResourceOrderForm: PropTypes.func.isRequired,
  manifestType: PropTypes.string.isRequired,
  viewOnly: PropTypes.bool,
  printManifest: PropTypes.func.isRequired,
  manifestFormActions: PropTypes.node,
}
